import * as fs from 'fs';
import {ApplicationScope} from "./ApplicationScope";
import {Config, Environment} from "./config";

export const migrateLocalDb = async (config: Config) => {

  // LEAVE THIS HERE AS A SANITY CHECK
  if (config.environment !== Environment.local)
    throw Error("You really don't want to migrate any DB other than local");

  try {
    console.log("Creating local DB...");
    const mssql = require(config.sqlLibraryName);
    const connection = await mssql.connect({...config.connectionParams[0], database: 'master'});

    try {
      await connection.query('DROP DATABASE sys2000;');
    } catch {
      console.log("Didn't drop sys2000 - maybe it already exists.")
    }

    await connection.query('CREATE DATABASE sys2000;');
    await mssql.close();

    console.log("Migrating DB..");
    const connection2 = await mssql.connect({...config.connectionParams[0]});
    const migrations = fs.readFileSync("migrate.sql", 'utf-8');
    await connection2.query(migrations);
    await mssql.close();

    console.log("Done migrating local DB...");
  } catch (e) {
    console.error(e)
  }
};


export const buildApplicationScope = async (config: Config, licenseKey: string): Promise<ApplicationScope> => {
 return ApplicationScope.build(config, licenseKey)
};
